import { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import sanityClient from '../../sanityClient';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';

export default function HomeExecute() {
    const [bannerData, setBannerData] = useState(null);
    const [homeExecuteContent, setHomeExecuteContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    // Fetch Banner Data & Home Page Content in a single useEffect
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [bannerDataResponse, contentResponse] = await Promise.all([
                    sanityClient.fetch(`*[_type == "bannerImageSection" && page == "homeExecute"][0]{
                        bannerType,
                        "imageUrl": bannerImage.asset->url,
                        bannerVideoUrl,
                        altText
                    }`),
                    sanityClient.fetch(`*[_type == "homePageContent"][0].homeprojectmanagmentexpertise`)
                ]);

                setBannerData(bannerDataResponse);
                setHomeExecuteContent(contentResponse);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Memoized Play/Pause Handler to prevent unnecessary re-renders
    const handlePlayPause = useCallback(() => {
        if (!bannerData) return;

        if (bannerData.bannerType === "video" && bannerData.bannerVideoUrl.includes("youtube")) {
            setIsPlaying((prev) => !prev);
        } else if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying((prev) => !prev);
        }
    }, [bannerData, isPlaying]);

    // Memoized JSX for better performance
    const bannerElement = useMemo(() => {
        if (!bannerData) return null;

        if (!isPlaying) {
            return <img src={bannerData.imageUrl} alt={bannerData.altText} className="img-responsive" loading="lazy" />;
        }

        if (bannerData.bannerType === "video" && bannerData.bannerVideoUrl.includes("youtube")) {
            return (
                <iframe className="img-responsive" src={`${bannerData.bannerVideoUrl}?autoplay=1&mute=1`} title="YouTube Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy"></iframe>
            );
        }

        return (
            <video className="img-responsive" src={bannerData.bannerVideoUrl} ref={videoRef} muted loop playsInline loading="lazy"/>
        );
    }, [bannerData, isPlaying]);

    if (loading) return <p></p>;

    return (
        <section className="home-execute">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="execute-container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 order-2 order-md-1">
                                    <div className="execute-textbox wow animate__animated animate__slideInLeft" data-wow-duration="1.4s" data-wow-delay="0.1s">
                                        <div>
                                            <img src="./assets/home/element.png" alt="vector" />
                                            <h4 className="heading">{homeExecuteContent?.title}</h4>
                                        </div>
                                        <div className='execute-process'>
                                            {["heading1", "heading2", "heading3", "heading4"].map((key, index) => (
                                                <div key={index}>
                                                    <span>{`0${index + 1}`}</span>
                                                    <p>{homeExecuteContent?.[key]}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 order-1 order-md-2">
                                    <div className="expertise-video m-0">
                                        {bannerElement}
                                        {/* <button
                                            className="play-expert"
                                            onClick={handlePlayPause}
                                            aria-label={isPlaying ? "Pause video" : "Play video"}
                                        >
                                            <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
